import { __read } from 'tslib';
import * as React from 'react';
import throttle from 'lodash/throttle';
import { isElementVisibleWithOffset } from './animation/visibility.esm.js';

var THROTTLE_DELAY = 100;
var TOP_OFFSET = -100;
function useElementVisibleAfterScroll(elementRef) {
    var _a = __read(React.useState(false), 2), isVisible = _a[0], setIsVisible = _a[1];
    var checkIsVisible = function () {
        var _a;
        if (elementRef !== null && elementRef.current !== null && !isVisible) {
            var rect = (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            setIsVisible(isElementVisibleWithOffset(rect, TOP_OFFSET));
        }
    };
    var listenToScroll = function () {
        checkIsVisible();
    };
    React.useEffect(function () {
        //listen to window scroll
        var throttledListenToScroll = throttle(listenToScroll, THROTTLE_DELAY);
        window.addEventListener('scroll', throttledListenToScroll);
        //clear listener on component unmount
        return function () { return window.removeEventListener('scroll', throttledListenToScroll); };
    }, []);
    return isVisible;
}

export { useElementVisibleAfterScroll as default };
//# sourceMappingURL=useIsElementVisibleAfterScroll.esm.js.map
